import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import OpportunityForm from './components/OpportunityForm/OpportunityForm.js';

function App() {
  return (
    <BrowserRouter>
        <Routes>
          <Route path="/" element={<OpportunityForm />} />
          <Route path="/user/:userId" element={<OpportunityForm />} />
          <Route path="/user/:userId/opportunity/:opportunityId" element={<OpportunityForm />} />
        </Routes>
    </BrowserRouter>
  );
}

export default App;